var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-content-border-box"},[_c('div',{staticClass:"menu-use-content-inside"},[_c('ul',{staticClass:"menu-use-box"},_vm._l((_vm.layoutStyleList),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.getNodeTypeAccout(item.nodeType)}}},[_c('img',{attrs:{"src":item.layoutIcon}})])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }